module.exports = __webpack_public_path__ + "images/help/icon-twr40@2x-8c54b416aebace80098500ed1738831b.png";